import { cn } from "@/utils/cn";
import { Container } from "./Container";

const BG = {
  ink: "bg-ink",
  charcoal: "bg-charcoal",
  dark: "bg-[#0A0A0A]",
};

// Standard page section: vertical rhythm, optional blueprint grid overlay, wrapped Container.
export const Section = ({
  id,
  testId,
  bg = "ink",
  blueprint = false,
  blueprintAnim = false,
  blueprintOpacity = 0.3,
  className = "",
  containerClassName = "",
  children,
}) => (
  <section id={id} data-testid={testId} className={cn("section relative", BG[bg], className)}>
    {blueprint && (
      <div
        className={cn("absolute inset-0 blueprint-bg", blueprintAnim && "blueprint-anim")}
        style={{ opacity: blueprintOpacity }}
      />
    )}
    <Container className={cn("relative", containerClassName)}>{children}</Container>
  </section>
);
